<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'PROPERTY_TYPE_TEMPLATES' }
  ]"
></breadcrumbs>

<page-header title="PROPERTY_TYPE_TEMPLATES"></page-header>

<app-table
  [isLoading]="isLoading"
  [rows]="state.get('data')"
  [columns]="columns"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('filtered')"
  [itemsPerPage]="getPagination('page_size')"
  [currentPage]="getPagination('page')"
  [sort]="getPagination('sort')"
  [orderBy]="getPagination('order_by')"
  (onPageChange)="onPageChange($event)"
  (onPageSizeChange)="onPageSizeChange($event)"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['create']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_TEMPLATE"
        >{{ 'CREATE_TEMPLATE' | translate }}</a
      >
    </div>
  </ng-template>

  <ng-template let-row="row" #actionsColumn>
    <alert #deleteAlert (confirm)="deleteTemplate(row.get('id'))" titleTrnKey="ARE_YOU_SURE" textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS" />
    <div class="buttons m-0">
      <a
        [routerLink]="[row.get('id'), 'update']"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <button
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>
</app-table>
